export default __webpack_public_path__ + "static/media/recommends.e0c71bd0.png";